// src/app/theme/useTheme.ts
import { useContext } from 'react';

import { ThemeEngineContext, type IThemeEngineContextValue } from './ThemeEngineProvider';

/**
 * The app's one sanctioned theme hook. Returns the active theme, the
 * setter, and the registered themes' metadata from the ThemeEngine via
 * ThemeEngineProvider's context. Must be used within
 * <ThemeEngineProvider> (mounted once, above <AppRouter />, in App.tsx).
 */
export function useTheme(): IThemeEngineContextValue {
  const ctx = useContext(ThemeEngineContext);

  if (!ctx) {
    throw new Error('useTheme() must be used within a <ThemeEngineProvider>.');
  }

  return ctx;
}
